{
  "title": "API keys",
  "description": "Personal keys that let an AI assistant build curriculum in this school through the Osvitly MCP server. Content a key creates stays a draft until you publish it; a class it creates starts empty until you enroll pupils.",
  "keys": {
    "title": "Keys",
    "name": "Name",
    "prefix": "Prefix",
    "owner": "Acts as",
    "created": "Created",
    "lastUsed": "Last used",
    "neverUsed": "Never",
    "status": "Status",
    "empty": "No keys yet.",
    "emptyTeacher": "You have no keys yet.",
    "loadFailed": "The keys could not be loaded.",
    "states": {
      "active": "Active",
      "paused": "Paused",
      "revoked": "Revoked"
    }
  },
  "create": {
    "trigger": "New key",
    "title": "Create an API key",
    "description": "The key is shown once, right after it is created. Store it somewhere safe before closing this dialog.",
    "name": "Name",
    "namePlaceholder": "Claude on my laptop",
    "nameHint": "Something that tells you which machine or tool holds this key.",
    "nameRequired": "Give the key a name.",
    "nameTooLong": "Use 50 characters or fewer.",
    "owner": "Acts as",
    "ownerHint": "The key can do exactly what this member can do, and every write is attributed to them.",
    "ownerSelf": "Yourself",
    "ownerSelfOnly": "A key is personal: it will act as you.",
    "submit": "Create key",
    "failed": "The key could not be created."
  },
  "reveal": {
    "title": "Copy your key now",
    "warning": "This is the only time the key is shown. It is stored hashed, so it can never be displayed again — if you lose it, revoke it and create another.",
    "label": "API key",
    "copy": "Copy key",
    "copied": "Key copied to the clipboard.",
    "copyFailed": "Copying failed — select the key and copy it manually.",
    "howTo": "How to use it",
    "howToIntro": "Register the MCP server with Claude Code:",
    "howToNote": "For a locally running stack, use http://localhost:8000/api as the API URL.",
    "acknowledge": "I've saved the key"
  },
  "revoke": {
    "action": "Revoke",
    "title": "Revoke “{{name}}”?",
    "description": "The key stops working immediately and cannot be restored. Its activity log stays, so you keep the record of what it did.",
    "confirm": "Revoke key",
    "success": "The key was revoked.",
    "failed": "The key could not be revoked."
  },
  "activity": {
    "title": "MCP activity",
    "description": "Every change made with a key, newest first. Reads are not logged.",
    "empty": "No activity yet.",
    "loadFailed": "The activity could not be loaded.",
    "viaKey": "via {{prefix}}",
    "noTarget": "—",
    "kinds": {
      "create": "Created",
      "update": "Updated",
      "delete": "Deleted",
      "publish": "Published",
      "other": "Changed"
    },
    "resources": {
      "course": "Course",
      "lesson": "Lesson",
      "module": "Module",
      "test": "Test",
      "question": "Question",
      "homework": "Homework",
      "project": "Project",
      "lesson_schedule": "Scheduled lesson",
      "class": "Class"
    }
  }
}
